module.exports = __webpack_public_path__ + "img/3-5.afaec56a.jpg";